const e = {
  code: "he",
  facebook: "he_IL",
  label: "עברית",
  loadingText: "טוען...",
  dir: "rtl",
  translations: {
    ar: "ערבית",
    de: "גרמנית",
    en: "אנגלית",
    es: "ספרדית",
    fr: "צרפתית",
    he: "עברית",
    hi: "הינדי",
    id: "אינדונזית",
    it: "איטלקית",
    ja: "יפנית",
    km: "חמר",
    ko: "קוריאנית",
    lo: "לאוסית",
    ms: "מלאית",
    nl: "הולנדית",
    pt: "פורטוגזית",
    ru: "רוסית",
    th: "תאילנדית",
    tl: "פיליפינית",
    tr: "טורקית",
    vi: "ויאטנמית",
    "zh-CN": "סינית (פשוטה)",
    "zh-TW": "סינית (מסורתית)"
  }
};
export {
  e as hebrew
};
